import { useState, useEffect, useCallback } from 'react';
import { useLocationContext } from '@/contexts/LocationContext';

export function useContactSearch(initialValue = '') {
  const [searchTerm, setSearchTerm] = useState(initialValue);
  const [debouncedTerm, setDebouncedTerm] = useState(initialValue);
  const { selectedLocationId } = useLocationContext();

  // Clear search when location changes
  useEffect(() => {
    setSearchTerm('');
    setDebouncedTerm('');
  }, [selectedLocationId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedTerm(searchTerm);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const clearSearch = useCallback(() => {
    setSearchTerm('');
    setDebouncedTerm('');
  }, []);

  return {
    searchTerm,
    setSearchTerm,
    debouncedTerm,
    clearSearch,
    hasSearch: debouncedTerm.length > 0,
  };
}
